import React from "react";

export const openBtn = async () => {
  const openButton = document.getElementById("openOnStatusChangeBtn");
  openButton.click();
};

export function ConfirmAlertPCWToAv(props) {
  const closeBtn = async () => {
    const closeButton = document.getElementById("closeOnStatusChangeBtn");
    closeButton.click();
  };

  return (
    <>
      {/* Hidden buttons for programmatically opening/closing the modal */}
      <button
        id="openOnStatusChangeBtn"
        type="button"
        className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        data-bs-toggle="modal"
        data-bs-target="#openOnStatusChangeID"
        style={{ display: "none" }}
      ></button>

      <button
        id="closeOnStatusChangeBtn"
        type="button"
        className="btn-close box-content w-4 h-4 p-1 text-cyan-500 border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
        data-bs-dismiss="modal"
        data-bs-target="#openOnStatusChangeID"
        aria-label="Close"
        style={{ display: "none" }}
      ></button>

      {/* Modal Dialog */}
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="openOnStatusChangeID"
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-modal="true"
        role="dialog"
      >
        <div className="flex items-center justify-center min-h-screen">
          <div className="modal-dialog modal-dialog-centered relative pointer-events-none mx-auto w-auto max-w-md">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              <div className="modal-header flex flex-shrink-0 items-center justify-center py-7 px-6 rounded-t-md">
                <div className="flex items-center justify-center flex-col">
                  <p className="text-black font-semibold text-xl">
                    Do you want to close the existing contact?
                  </p>
                </div>
              </div>
              <div className="modal-body relative flex justify-between p-4" style={{ height: "80px" }}>
                <button
                  onClick={() => {
                    props.fn();
                    closeBtn();
                  }}
                  className="flex justify-center items-center border-none bg-cyan-500 text-white py-2 px-6 rounded-md"
                  style={{ width: "45%", height: "80%" }}
                  data-bs-toggle="modal"
                  data-bs-target="#openOnStatusChangeID"
                >
                  <p className="text-lg text-white">Yes</p>
                </button>
                <button
                  onClick={() => closeBtn()}
                  className="flex justify-center items-center border-none bg-cyan-500 text-white py-2 px-6 rounded-md"
                  style={{ width: "45%", height: "80%" }}
                  data-bs-toggle="modal"
                  data-bs-target="#openOnStatusChangeID"
                >
                  <p className="text-lg text-white">Cancel</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}